// src/theme/accordion.ts
var accordionTheme = {
  defaultProps: {
    type: "single"
  }
};
var accordionItemTheme = {
  defaultProps: {
    disabled: false
  },
  baseStyle: "group block w-full items-center justify-between cursor-pointer border-b border-surface aria-disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:select-none"
};
var accordionTriggerTheme = {
  baseStyle: "flex items-center justify-between w-full py-5 text-left font-medium dark:text-white text-black"
};
var accordionContentTheme = {
  baseStyle: "block pb-5 text-sm text-foreground h-0 data-[open=true]:h-auto"
};

export {
  accordionTheme,
  accordionItemTheme,
  accordionTriggerTheme,
  accordionContentTheme
};
